import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { EventVersion } from '../models/event-version';
import * as firebase from 'firebase/app';


@Injectable()
export class PublishResetService {

  constructor(private db: AngularFireDatabase, private utilityService:UtilityService) { }

  getEventVersionData(id: string):Observable<EventVersion> {
    if(id != null) {
      let data :AngularFireObject<EventVersion> = this.db.object(Constants.EVENT_URL+'/'+id+Constants.EVENT_VERSION);
      return  data.valueChanges();
    }
    return null;
  }

  getLastPublishedAt(id:string):Observable<any> {
    if(id != null) {
      let data :AngularFireObject<EventVersion> = this.db.object(Constants.EVENT_URL+'/'+id+'/'+'publishedAt');
      return  data.valueChanges();
    }
    return null;
  }

  updateVersion(eventId: string, eventVersion: EventVersion, desc:string){
    if(!desc) {
      this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.EVENT_VERSION).set(eventVersion);
    }else{
      this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.EVENT_VERSION).set(eventVersion);
      this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.EVENT_VERSION+'/'+'notesHistory').update({['v'+eventVersion.cv] : desc});
    }
  }

  getEventWebObject(id: string) {
    return firebase.database().ref(Constants.EVENT_URL+'/'+id).once('value');
  }

  copyEventWebToEventApp(event: any, eventId:string):Promise<any> {
    this.db.object(Constants.EVENT_URL+'/'+eventId).update({['publishedAt'] : new Date().getTime()}).then(res=>{});
    let newEvent = Object.assign({}, event);
    return this.db.object(Constants.EVENT_APP_URL+'/'+eventId).set(newEvent);
  }

  getEventAppObject(id: string) {
    return firebase.database().ref(Constants.EVENT_APP_URL+'/'+id).once('value');
  }

  copyEventAppToEventWeb(event: any, eventId:string):Promise<any> {
    let newEvent = Object.assign({},event);
    return this.db.object(Constants.EVENT_URL+'/'+eventId).set(newEvent);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/publish-reset.service.ts